import { render } from "./MinistryUsers.vue?vue&type=template&id=23b38ad9&scoped=true"
import script from "./MinistryUsers.vue?vue&type=script&lang=js"
export * from "./MinistryUsers.vue?vue&type=script&lang=js"

import "./MinistryUsers.vue?vue&type=style&index=0&id=23b38ad9&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23b38ad9"]])

export default __exports__